<template>
  <div class="my-calendar" v-if="loaded">
    <date-picker
      element="month1"
      v-model="month"
      type="month"
      color="#4BA0E7"
      @change="getNumberOfDays()"
    >
    </date-picker>
    <date-picker
      element="year1"
      v-model="year"
      type="year"
      color="#4BA0E7"
      @change="getNumberOfDays()"
    >
    </date-picker>
    <v-menu
      attach
      :close-on-content-click="false"
      :close-on-click="false"
      origin="center center"
      transition="scale-transition"
      v-model="calendarMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="customSelect2 pe-3 pb-2"
          v-bind="attrs"
          v-on="on"
          @click="openCalendar()"
        >
          <span class="c-blue pt-3 pe-2">
            {{ label ? label : "" }}
            <span class="px-2 grey--text text--darken-2">{{
              computedFilterDate
            }}</span>
          </span>
          <div v-if="icon == 'arrow'">
            <v-icon v-if="!calendarMenu" class="c-blue pt-2">$ArrowDown</v-icon>
            <v-icon v-else class="c-blue pt-2">$ArrowUp</v-icon>
          </div>
          <div v-else>
            <v-icon class="c-blue pt-2">$Calendar</v-icon>
          </div>
        </div>
      </template>

      <v-card class="timeFilter-card pa-4">
        <div
          v-if="calendarType == 'startDate'"
          class="px-2 mb-4 grey--text fs-xsmall text--darken-2 text-center"
        >
          <b class="primary--text">تاریخ شروع</b> مورد نظر را انتخاب نمایید
        </div>
        <div
          v-else
          class="px-2 mb-4 grey--text fs-xsmall text--darken-2 text-center"
        >
          <b class="primary--text">تاریخ پایان</b> مورد نظر را انتخاب نمایید
        </div>
        <v-divider></v-divider>
        <v-row class="mt-1">
          <v-col class="d-flex">
            <span class="pointer" @click="nextMonth()"
              ><v-icon>mdi-chevron-right</v-icon></span
            >
            <div
              id="month1"
              class="pointer text-center"
              style="min-width: 55px"
            >
              {{ persianMonthName(month) }}
            </div>

            <span class="pointer" @click="lastMonth()"
              ><v-icon>mdi-chevron-left</v-icon></span
            >
          </v-col>
          <v-col class="text-left">
            <div class="d-flex ms-auto" style="width: fit-content">
              <span @click="nextYear()" class="pointer"
                ><v-icon>mdi-chevron-right</v-icon></span
              >
              <div class="text-center" style="min-width: 55px">
                {{ year }}
              </div>

              <span @click="lastYear()" class="pointer"
                ><v-icon>mdi-chevron-left</v-icon></span
              >
            </div>
          </v-col>
        </v-row>
        <div class="mt-4">
          <span v-if="deviceType != 'mobile'">
            <div
              v-for="(day, index) in weekDays"
              :key="index"
              class="weekday-box d-inline-block"
            >
              {{ day }}
            </div>
          </span>
          <span v-else>
            <div
              v-for="(day, index) in weekDaysMobile"
              :key="index"
              class="weekday-box d-sm-none d-inline-block"
            >
              {{ day }}
            </div>
          </span>
        </div>
        <span v-if="deviceType != 'mobile'">
          <div
            v-for="(number, index) in numberOfDay"
            :key="index"
            class="day-box d-sm-inline-block d-none pointer"
            :style="
              index == 0
                ? 'margin-right:' + 59 * numberOfWeekDay.value + 'px;'
                : ''
            "
          >
            <div
              class="mx-auto"
              :class="
                checkDate(number, calendarType)
                  ? 'selectedTime'
                  : calendarType == 'endDate' && disabledDate(number)
                  ? 'disabled'
                  : ''
              "
              :style="
                isBetween(number) && calendarType == 'endDate'
                  ? 'background-color: #f2e3e3 !important; color:#bf0000'
                  : ''
              "
              @click="selectDate(number, calendarType)"
            >
              {{ number }}
            </div>
          </div>
        </span>
        <span v-else>
          <div
            v-for="(number, index) in numberOfDay"
            :key="index"
            class="day-box d-sm-none d-inline-block pointer"
            :style="
              index == 0
                ? 'margin-right:' + 36 * numberOfWeekDay.value + 'px;'
                : ''
            "
          >
            <div
              class="mx-auto"
              :class="
                checkDate(number, calendarType)
                  ? 'selectedTime'
                  : calendarType == 'endDate' && disabledDate(number)
                  ? 'disabled'
                  : ''
              "
              :style="
                isBetween(number) && calendarType == 'endDate'
                  ? 'background-color: #f2e3e3 !important; color:#bf0000'
                  : ''
              "
              @click="selectDate(number, calendarType)"
            >
              {{ number }}
            </div>
          </div>
        </span>
        <v-row class="mt-0 mb-2">
          <v-col class="pe-0 pb-0 text-center">
            <div class="custom-input-calendar d-flex flex-row ps-md-5 ps-0">
              <span
                class="c-grey fs-xsmall font-weight-bold pt-3 pe-1"
                :class="calendarType == 'startDate' ? 'primary--text ' : ''"
                >از:</span
              >
              <v-text-field
                dense
                hide-details
                outlined
                readonly
                color="#bf0000"
                append-icon="mdi-square-edit-outline"
                @click:append="
                  calendarType = 'startDate';
                  updateMonth();
                "
                @click="
                  calendarType = 'startDate';
                  updateMonth();
                "
                :class="calendarType == 'startDate' ? 'selectedField' : ''"
                v-model="startDate2"
              >
              </v-text-field>
            </div>
          </v-col>
          <v-col class="ps-3">
            <div class="custom-input-calendar d-flex">
              <span
                class="c-grey fs-xsmall font-weight-bold pt-3 pe-1"
                :class="calendarType == 'endDate' ? 'primary--text' : ''"
                >تا:</span
              >
              <v-text-field
                dense
                hide-details
                outlined
                readonly
                color="#bf0000"
                append-icon="mdi-square-edit-outline"
                :class="calendarType == 'endDate' ? 'selectedField' : ''"
                @click="
                  calendarType = 'endDate';
                  updateMonth();
                "
                @click:append="
                  calendarType = 'endDate';
                  updateMonth();
                "
                v-model="endDate2"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>

        <div class="text-left mt-3">
          <v-btn class="me-2 primary" @click="calendarMenu = false">بستن</v-btn>
          <v-btn class="secondary me-2" @click="submitDate()">اعمال</v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: ["start", "end", "label", "icon"],
  data() {
    return {
      moment: moment,
      deviceType: "",
      startDate: "",
      endDate: "",
      startDate2: "",
      endDate2: "",
      calendarMenu: false,
      weekDays: [
        "شنبه",
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنج‌شنبه",
        "جمعه",
      ],
      weekDaysMobile: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      daysOfWeek: [
        {
          text: "یکشنبه",
          value: 1,
        },
        {
          text: "دوشنبه",
          value: 2,
        },
        {
          text: "سه‌شنبه",
          value: 3,
        },
        {
          text: "چهارشنبه",
          value: 4,
        },
        {
          text: "پنجشنبه",
          value: 5,
        },
        {
          text: "جمعه",
          value: 6,
        },
        {
          text: "شنبه",
          value: 0,
        },
      ],
      currentYear: moment(new Date()).format("jYYYY"),
      currentMonth: moment(new Date()).format("jMM"),
      year: moment(new Date()).format("jYYYY"),
      month: moment(new Date()).format("jMM"),
      day: moment(new Date()).format("jDD"),
      selectedyear: "",
      selectedMonth: "",
      numberOfDay: null,
      numberOfWeekDay: null,
      calendarType: "startDate",
      reactivity: false,
      loaded: false,
    };
  },
  methods: {
    openCalendar() {
      this.calendarType = "startDate";
      this.startDate2 = JSON.parse(JSON.stringify(this.startDate));
      this.endDate2 = JSON.parse(JSON.stringify(this.endDate));
      this.updateMonth();
      this.getNumberOfDays();
    },
    showNow() {
      this.year = this.currentYear;
      this.month = this.currentMonth;
      this.getNumberOfDays();
    },
    getNumberOfDays() {
      if (1 <= parseInt(this.month) && parseInt(this.month) < 7) {
        this.numberOfDay = 31;
      }
      if (7 <= parseInt(this.month) && parseInt(this.month) != 12) {
        this.numberOfDay = 30;
      }
      if (parseInt(this.month) == 12) {
        let isLead = moment(this.year + "/12/30", "jYYYY/jMM/jDD").isValid();
        if (isLead) {
          this.numberOfDay = 30;
        } else this.numberOfDay = 29;
      }

      if (parseInt(this.day) > parseInt(this.numberOfDay)) {
        this.day = this.numberOfDay;
      }
      let date = this.year + "/" + this.month + "/" + "01";

      let day = moment(date, "jYYYY/jMM/jDD").format("d");
      this.numberOfWeekDay = this.daysOfWeek[day];
      // alert(this.numberOfWeekDay.value);
      // alert(this.numberOfDay);
    },
    persianMonthName(month) {
      let monthName;
      monthName = this.monthsName[Number(month) - 1];
      return monthName;
    },

    nextMonth() {
      if (Number(this.month) < 12) {
        this.month = Number(this.month) + 1;
        if (Number(this.month) < 10) {
          this.month = "0" + this.month;
        }
      } else {
        this.month = "01";
      }
      this.getNumberOfDays();
    },
    lastMonth() {
      if (Number(this.month) > 1) {
        this.month = Number(this.month) - 1;
        if (Number(this.month) < 10) {
          this.month = "0" + this.month;
        }
      } else {
        this.month = 12;
      }
      this.getNumberOfDays();
    },
    nextYear() {
      this.year = Number(this.year) + 1;
      this.getNumberOfDays();
    },
    lastYear() {
      this.year = Number(this.year) - 1;
      this.getNumberOfDays();
    },
    checkDate(number, type) {
      if (number < 10) {
        if (this[type + "2"] == this.year + "/" + this.month + "/0" + number) {
          return true;
        } else return false;
      } else {
        if (this[type + "2"] == this.year + "/" + this.month + "/" + number) {
          return true;
        } else return false;
      }
    },
    isBetween(number) {
      let startDate = moment(this.startDate2, "jYYYY/jMM/jDD").format("X");
      let endDate = moment(this.endDate2, "jYYYY/jMM/jDD").format("X");
      if (
        startDate <=
          moment(
            this.year + "/" + this.month + "/" + number,
            "jYYYY/jMM/jDD"
          ).format("X") &&
        endDate >
          moment(
            this.year + "/" + this.month + "/" + number,
            "jYYYY/jMM/jDD"
          ).format("X")
      ) {
        return true;
      } else return false;
    },
    selectDate(number, type) {
      if (number < 10) {
        this[type + "2"] = this.year + "/" + this.month + "/0" + number;
      } else {
        this[type + "2"] = this.year + "/" + this.month + "/" + number;
      }
      this.checkDate();
      if (this.calendarType == "startDate") {
        this.endDate2 = moment(this.startDate2, "jYYYY/jMM/jDD")
          .add(7, "day")
          .format("jYYYY/jMM/jDD");
        this.calendarType = "endDate";
        this.updateMonth();
      }
    },
    updateMonth() {
      if (this.calendarType == "startDate") {
        this.month = this.startDate2.split("/")[1];
      } else {
        this.month = this.endDate2.split("/")[1];
      }
    },
    disabledDate(number) {
      let startDate = moment(this.startDate2, "jYYYY/jMM/jDD").format("X");
      let theDay = moment(
        this.year + "/" + this.month + "/" + number,
        "jYYYY/jMM/jDD"
      ).format("X");
      if (startDate > theDay) {
        return true;
      } else return false;
    },
    submitDate() {
      this.startDate = this.startDate2;
      this.endDate = this.endDate2;
      this.$emit("getStartDate", this.startDate2);
      this.$emit("getEndDate", this.endDate2);
      this.$emit("submit");
      this.calendarMenu = false;
    },
  },
  computed: {
    computedFilterDate() {
      if (this.startDate && this.endDate) {
        let date =
          "از تاریخ " +
          this.startDate.split("/")[2] +
          "/" +
          this.persianMonthName(this.startDate.split("/")[1]) +
          "/" +
          this.startDate.split("/")[0] +
          " تا تاریخ " +
          this.endDate.split("/")[2] +
          "/" +
          this.persianMonthName(this.endDate.split("/")[1]) +
          "/" +
          this.endDate.split("/")[0];

        return date;
      }
    },
  },
  mounted() {
    this.startDate = this.start;
    this.endDate = this.end;
    setTimeout(() => {
      this.loaded = true;
    }, 10);
    if (window.screen.width < 768) {
      this.deviceType = "mobile";
    } else if (window.screen.width > 768 && window.screen.width < 1024) {
      this.deviceType = "tablet";
    }
  },
};
</script>

<style lang="scss">
.v-menu__content {
  border: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  transform: translateY(-50px);
}

@media only screen and (max-width: 600px) {
  .v-menu__content {
    transform: translateY(0px);
  }
}

.timeFilter-card {
  width: 453px;
  border: 1px solid #ccc !important;
  border-radius: 8px !important;
  .custom-input {
    .v-input__slot {
      width: 135px !important;
      input {
        cursor: pointer;
      }
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 44px !important;
      cursor: pointer;
    }
  }
  .custom-input-calendar {
    .v-input__slot {
      width: 170px !important;
      input {
        cursor: pointer;
      }
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 44px !important;
      cursor: pointer;
    }
  }
  .selectedField {
    .v-input__slot {
      color: #bf0000;
      background-color: #bf00000a;
      input {
        color: #bf0000;
      }
    }
    .mdi:before {
      color: #bf0000;
    }
  }
  .day-box {
    width: 59px;
    height: 40px;
    margin: 1px 0;
    text-align: center;
    border-radius: 50%;
    color: #656a81;
    font-size: 0.9rem;
    div {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background-color: #eeeeee;
        color: #656a81;
      }
    }

    .selectedTime {
      background-color: #bf0000;
      color: #fff;
    }
  }
  .weekday-box {
    width: 59px;
    height: 48px;
    text-align: center;
    border-radius: 50%;
    padding-top: 6px;
    color: #aaaaaa;
    font-size: 0.87rem;
  }

  //mobile mood
  @media only screen and (max-width: 600px) {
    width: 286px !important;

    .custom-input {
      .v-input__slot {
        width: 200px !important;
        input {
          cursor: pointer;
        }
      }
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 44px !important;
        cursor: pointer;
      }
    }
    .day-box {
      width: 36px;
      height: 40px;
      margin: 1px 0;
      text-align: center;
      border-radius: 50%;
      color: #656a81;
      font-size: 0.9rem;
      div {
        width: 33px;
        height: 33px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background-color: #eeeeee;
          color: #656a81;
        }
      }

      .selectedTime {
        background-color: #bf0000;
        color: #fff;
      }
    }
    .weekday-box {
      width: 36px;
      height: 48px;
      text-align: center;
      border-radius: 50%;
      color: #aaaaaa;
      font-size: 0.87rem;
    }
  }
}
.custom-select {
  width: fit-content;
  border: 1px solid #ccc;
  font-size: 0.9rem;
}
</style>
